import { SelectionModel } from '@angular/cdk/collections';
import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { PurchaseOrderService } from '../../pages/purchase-order/purchase-order-service';
import { Data } from '@angular/router';
export interface PeriodicElement {
  position?: any;
  heading: any;
  description: any;
  erTermsKey?: any;  
}
@Component({
  selector: 'app-terms-condition-dialog',
  templateUrl: './terms-condition-dialog.component.html',
  styleUrls: ['./terms-condition-dialog.component.scss']
})
export class TermsConditionDialogComponent implements OnInit {
  public otherChargesForm: UntypedFormGroup;
  public displayedColumns = ['select', 'position', 'heading', 'description'];
  dataSource = new MatTableDataSource<PeriodicElement>();
  selection = new SelectionModel<PeriodicElement>(true, []);
  termsData: any;
  erTermsKey: any;
  viewType: any;
  editType: any;
  termsType: string = 'ALL'; // NEW — default keeps existing PO behavior unchanged

  constructor(
    public dialogRef: MatDialogRef<TermsConditionDialogComponent>,
    private poService: PurchaseOrderService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    if (this.data) {
      this.viewType = this.data.viewType;
      this.editType = this.data.editType;
      this.termsType = this.data.type || 'ALL'; // NEW — read the caller's requested type

      if (this.data.data) {
        this.termsData = this.data.data;
      }

      if (this.data.description) {
        this.form.patchValue({ description: this.data.description });
      }

      if (this.termsData == null) {
        this.getAllTerms();
      }
    }
  }

  form = new FormGroup({
    erTermsKey: new FormControl(''),
    description: new FormControl('', [
      Validators.maxLength(1000)
    ])
  });

  get f() {
    return this.form.controls;
  }

  ngOnInit(): void {
    this.getAllTerms();

    if (this.viewType === 'VIEW' || this.viewType === 'Tax_Convert') {
      this.form.disable();
    }
  }

  getAllTerms() {
    this.poService.getAllTermsByType(this.termsType).subscribe({ // CHANGED — was hardcoded 'ALL'
      next: (res) => {
        const terms = Array.isArray(res) ? res : res?.data || [];
        this.dataSource.data = terms;

        if (this.termsData) {
          const selectedKeys = Array.isArray(this.termsData)
            ? this.termsData.map((term: any) => term.erTermsKey)
            : [this.termsData.erTermsKey];

          const selectedRows = this.dataSource.data.filter((row: any) =>
            selectedKeys.includes(row.erTermsKey)
          );

          this.selection.select(...selectedRows);
        }
      },
      error: (error) => {
        console.error('Failed to load terms and conditions', error);
        this.dataSource.data = [];
      },
    });
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }
  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }

    this.selection.select(...this.dataSource.data);
  }
  checkboxLabel(row?: PeriodicElement): string {
    if (!row) {
      return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  }

  save() {
    // CHANGED: return both the selected terms AND the description text
    this.dialogRef.close({
      selectedTerms: this.selection.selected,
      description: this.form.get('description')?.value || ''
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}
